import React from "react";

export default function MovingUpIcon({ className = "" }) {
  return (
    <svg 
      width="14" 
      height="9" 
      viewBox="0 0 14 9" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M1.26683 8.5L0.333496 7.56667L3.86683 4.03333C4.25572 3.64444 4.72794 3.45 5.2835 3.45C5.83905 3.45 6.31127 3.64444 6.70016 4.03333L7.46683 4.8C7.60016 4.93333 7.7585 5 7.94183 5C8.12516 5 8.2835 4.93333 8.41683 4.8L11.3835 1.83333H9.66683V0.5H13.6668V4.5H12.3335V2.78333L9.35016 5.75C8.96128 6.13889 8.48905 6.33333 7.9335 6.33333C7.37794 6.33333 6.90572 6.13889 6.51683 5.75L5.7335 4.96667C5.61127 4.84444 5.45572 4.78333 5.26683 4.78333C5.07794 4.78333 4.92239 4.84444 4.80016 4.96667L1.26683 8.5Z" fill="currentColor"/>
    </svg>
  );
} 